import { getMinutes as getMinutesFns } from 'date-fns';

export default function getMinutes(date: Date): number {
  return getMinutesFns(date);
}
